import { useEffect, useMemo } from 'react';
import { PRODUCT_DISCOVERY_PROJECT } from '@atlassian/jira-common-constants/src/project-types.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';
import { useIsPremiumEdition } from '@atlassian/jira-polaris-lib-entitlement-utils/src/index.tsx';
import { useAccountId } from '@atlassian/jira-tenant-context-controller/src/components/account-id/index.tsx';
import { BANNER_NAME } from '../constants.tsx';
import {
	useJpdPremiumOnboardingBannerState,
	useJpdPremiumOnboardingBannerActions,
} from './store/index.tsx';
import { useHasPolarisInPath } from './helpers.tsx';

export const useBannerJpdPremiumOnboarding = () => {
	const hasPolarisInPath = useHasPolarisInPath();
	const { data: project } = useProjectContext();
	const isPremiumEdition = useIsPremiumEdition();
	const accountId = useAccountId();
	const { isDismissed, height, shouldShow, isLoading } = useJpdPremiumOnboardingBannerState();
	const { fetchBannerVisibility } = useJpdPremiumOnboardingBannerActions();
	const isDiscoveryProject = project?.projectType === PRODUCT_DISCOVERY_PROJECT;
	const isInJpdBoundary = useMemo(
		() => hasPolarisInPath || isDiscoveryProject,
		[isDiscoveryProject, hasPolarisInPath],
	);

	useEffect(() => {
		if (!accountId || !fg('polaris_pol-15006_premium_onboarding_banner')) {
			return;
		}

		fetchBannerVisibility(accountId);
	}, [accountId, fetchBannerVisibility]);

	return useMemo(
		() => ({
			isEnabled:
				isInJpdBoundary &&
				isPremiumEdition &&
				shouldShow &&
				!isDismissed &&
				!isLoading &&
				fg('polaris_pol-15006_premium_onboarding_banner'),
			name: BANNER_NAME,
			height,
		}),
		[isInJpdBoundary, isPremiumEdition, shouldShow, isDismissed, height, isLoading],
	);
};
